module.exports = __webpack_public_path__ + "static/expresioncorporal-2d0465dd380faf750678149c0e34eb29.jpg";